<template>
  <div class="btn-group">
    <button v-if="canView && !isTrashed" class="btn btn-secondary btn-sm" @click="view">
      <i class="fas fa-eye"></i>
    </button>
    <button v-if="canEdit && !isTrashed" class="btn btn-secondary btn-sm" @click="edit">
      <i class="fas fa-edit"></i>
    </button>
    <button v-if="canDelete && !isTrashed" class="btn btn-danger btn-sm" @click="confirmDeleting">
      <i class="fas fa-trash-alt"></i>
    </button>
    <button v-if="canRestore && isTrashed" class="btn btn-success btn-sm" @click="confirmRestoring">
      <i class="fas fa-reply"></i>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    row: Object,
  },

  computed: {
    /**
     * @return {boolean}
     */
    canView() {
      return this.row.canView;
    },

    /**
     * @return {boolean}
     */
    canEdit() {
      return this.row.canEdit;
    },

    /**
     * @return {boolean}
     */
    canDelete() {
      return this.row.canDelete;
    },

    /**
     * @return {boolean}
     */
    canRestore() {
      return this.row.canRestore;
    },

    /**
     * @return {string}
     */
    editUrl() {
      return this.row.editUrl;
    },

    /**
     * @return {string}
     */
    viewUrl() {
      return this.row.viewUrl;
    },

    /**
     * @return {string}
     */
    deleteUrl() {
      return this.row.deleteUrl;
    },

    /**
     * @return {string}
     */
    restoreUrl() {
      return this.row.restoreUrl;
    },

    /**
     * @return {boolean}
     */
    isTrashed() {
      return this.row.isTrashed;
    },
  },

  methods: {
    /**
     * @event edit
     */
    edit() {
      this.$emit('edit', {row: this.row, url: this.editUrl});
    },

    /**
     * @event edit
     */
    view() {
      this.$emit('view', {row: this.row, url: this.viewUrl});
    },

    /**
     * @event delete
     */
    confirmDeleting() {
      this.$confirm('Are you sure you want to delete this item?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
          .then(() => this.$emit('delete', {row: this.row, url: this.deleteUrl}))
          .catch(() => null);
    },

    /**
     * @event restore
     */
    confirmRestoring() {
      this.$confirm('Are you sure you want to restore this item?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
          .then(() => this.$emit('restore', {row: this.row, url: this.restoreUrl}))
          .catch(() => null);
    },
  },
}
</script>
